import axios from '@/plugins/axios.js'
// import {MessageBox} from 'element-ui'

export function removeItem(id) {
    return axios.delete("/receivable/item/" + id);
}

export function saveReceDetail(param) {
    return axios.post("receivable/detail/save", param);
}

export function listItem(params) {
    return axios.get("receivable/item/list", { params: params });
}

export function listReceivable(params) {
    return axios.get("/receivable/list", { params: params });
}

export function exportItem(params) {
    let config = {
        responseType: "blob",
        params: params
    };
    return axios.get("/receivable/item/export", config);
}